// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__3VQ06","spin":"Spinner_spin__3z5Id","white":"Spinner_white__1uhr6"};